module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres10-3df09250f9e54fd25f2567526927ecb2.jpg";